import { VExpandXTransition } from 'vuetify/lib/components/transitions';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VExpandXTransition,{staticClass:"w-expandable-x"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value),expression:"value"}],staticClass:"w-expandable-x__content-wrapper"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }